import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import Routes from "./routes";
import DeliveryContext from "./context/deliveryContext";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <DeliveryContext>
          <Routes />
        </DeliveryContext>
      </PersistGate>
    </Provider>
  );
}

export default App;
